import React from 'react'
import Template from '../../layout/Template';
import AgendaComp from './AgendaComp';
import { usePermissoes } from '../../hooks/usePermissoes';
import PermissoesComponent from '../../components/PermissaoComponent';
import AgendaAgendamentos from './AgendaAgendamentos';



const Agenda = () => {


    const { listPermissoes, isLoadingPerm } = usePermissoes([
        { secoesId: 2, acoesId: 1 },
        { secoesId: 2, acoesId: 2 },
        { secoesId: 2, acoesId: 3 },
        { secoesId: 2, acoesId: 4 }
    ])
    return (
        <Template>
            <h3 className='text-primary'>Agenda</h3>
            <hr></hr>
            {(!listPermissoes?.ver && !isLoadingPerm) ? (<PermissoesComponent showMsg={true}></PermissoesComponent>) : (
                <>
                    <AgendaAgendamentos/>
                </>)}

        </Template>
    )

}

export default Agenda;